import type { FormParam, FormSteps } from '@/features/withdraw-bank-transfer';
import type { InputFormat } from '@/entities/bank-address';

export const getParamForTypeDetermination = (
  param: FormParam,
  currentStepIndex: number,
  steps: FormSteps
): FormParam => {
  if (currentStepIndex === 0) {
    return param;
  }

  for (let i = 0; i < currentStepIndex; i++) {
    const step = steps[i];
    if (!step) continue;

    const foundParam = step.params.find(p => p.paramId === param.paramId);

    if (foundParam) {
      return foundParam;
    }
  }

  return param;
};

export const isParamInPrevStep = (
  param: FormParam,
  currentStepIndex: number,
  steps: FormSteps
) => {
  if (currentStepIndex === 0) {
    return false;
  }

  for (let i = 0; i < currentStepIndex; i++) {
    const step = steps[i];
    if (!step) continue;

    const foundParam = step.params.find(p => p.paramId === param.paramId);

    if (foundParam) {
      return true;
    }
  }

  return false;
};

export const isEditableParam = (param: FormParam) => {
  const hasValueList = Array.isArray(param.valueList);

  return (
    'defaultValue' in param ||
    !hasValueList ||
    (hasValueList && param!.valueList!.length > 1)
  );
};

export const getParamValue = (param: FormParam) => {
  if (Array.isArray(param.valueList)) {
    if (param.valueList.length === 1) {
      return param.valueList[0];
    } else if ('defaultIndex' in param) {
      const index = param.defaultIndex;

      if (typeof index === 'string') {
        return index;
      }

      return param.valueList[param.defaultIndex as number];
    } else {
      return '';
    }
  }

  if ('defaultValue' in param) {
    return param.defaultValue;
  }

  return '';
};

export const isParamSelect = (param: FormParam) => {
  return Array.isArray(param.valueList) && param.valueList.length > 1;
};

export const isSelectAddress = (param: FormParam) => {
  return param.action === 'selectTemplates';
};

export const isSelectBankCountry = (param: FormParam) => {
  return (
    param.paramId === 'bankCountry' && param.valueDictionaryId === 'countries'
  );
};

export const formatValue = (value: string, paramInputFormat?: InputFormat) => {
  const inputFormat = paramInputFormat || 'any';

  switch (inputFormat) {
    case 'numbers':
      return value.replace(/[^0-9]/g, '');

    case 'numbersLatin':
      return value.replace(/[^0-9a-zA-Z]/g, '');

    case 'any':
    default:
      return value;
  }
};
